import { useEffect } from 'react';
import {
    Box,
    Flex,
    Text,
    Button,
    VStack,
    HStack,
    useColorModeValue,
    SlideFade,
} from '@chakra-ui/react';
import { useTranslation } from '../../hooks/useTranslation';
import { useCookieConsent } from '../../hooks/useCookieConsent';
import { useLocation } from 'react-router-dom';

const CookieBanner = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { hasConsent, isInitialized, acceptCookies, declineCookies } = useCookieConsent();
    
    const bgColor = useColorModeValue('white', 'gray.800');
    const borderColor = useColorModeValue('gray.200', 'gray.600');



    const handleSettings = () => {
        // Redirigir a la página de política de cookies
        window.location.href = '/politica-de-cookies';
    };

    // No mostrar banner hasta que se inicialice
    if (!isInitialized) {
        return null;
    }

    // No mostrar banner en la página de política de cookies
    if (location.pathname === '/politica-de-cookies') {
        return null;
    }

    if (hasConsent !== false) {
        return null;
    }
    return (
        <SlideFade in={true} offsetY="20px">
            <Box
                position="fixed"
                bottom="0"
                left="0"
                right="0"
                bg={bgColor}
                borderTop="1px solid"
                borderColor={borderColor}
                p={4}
                zIndex={9999}
                boxShadow="lg"
            >
                <Flex
                    maxW="1200px"
                    mx="auto"
                    direction={{ base: 'column', md: 'row' }}
                    align={{ base: 'stretch', md: 'center' }}
                    justify="space-between"
                    gap={4}
                >
                    <VStack align="start" flex={1} spacing={2}>
                        <Text fontWeight="bold" fontSize="lg">
                            {t('cookies.banner.title')}
                        </Text>
                        <Text fontSize="sm" color="gray.600">
                            {t('cookies.banner.description')}
                        </Text>
                    </VStack>
                    
                    <HStack spacing={3} flexShrink={0}>
                        <Button
                            size="sm"
                            variant="outline"
                            onClick={handleSettings}
                        >
                            {t('cookies.banner.settings')}
                        </Button>
                        <Button
                            size="sm"
                            variant="ghost"
                            onClick={declineCookies}
                        >
                            {t('cookies.banner.decline')}
                        </Button>
                        <Button
                            size="sm"
                            colorScheme="blue"
                            onClick={acceptCookies}
                        >
                            {t('cookies.banner.accept')}
                        </Button>
                    </HStack>
                </Flex>
            </Box>
        </SlideFade>
    );
};

export default CookieBanner; 